<template>
  <div class="list-page">
	<Header></Header> <!-- 头部 -->
	<div class="content">
		<van-cell-group class="subform no-top-border">
			<div class="mt20" v-for="items in lists">
			  <!--  <van-grid-item :text="items.groupName" /> -->
			  <!-- 表单元素 -->
			  <div class="with100" v-for="item in items.groupFields">
				<!-- 单行文本框 -->
				<van-cell v-if="item.IS_ALLOW_EDIT==1 && item.UI_TYPE == 'TextBox'" :title="item.LABEL_NAME" :class="item.IS_MANDATORY==1?'t-input required-x':'t-input'">
				 	<van-field
						v-model="f_input[item.COLUMN_NAME]"
				 	    :name="item.COLUMN_NAME"
				 	    placeholder=""
				 	/>
				</van-cell>
				<van-cell v-else-if="item.IS_ALLOW_EDIT==1 && item.UI_TYPE == 'NumberBox'" :title="item.LABEL_NAME" :class="item.IS_MANDATORY==1?'t-input required-x':'t-input'">
				 	<van-field
				 	  readonly
				 	  clickable
				 	  v-model="f_number[item.COLUMN_NAME]"
				 	  :name="item.COLUMN_NAME"
				 	  @touchstart.native.stop="is_num_show = true"
				 	/>
				</van-cell> 
				<!-- 时间 年月日 -->
				<van-cell v-else-if="item.IS_ALLOW_EDIT==1 && item.UI_TYPE == 'DateBox'" :class="item.IS_MANDATORY==1?'required-x':''" :title="item.LABEL_NAME" :name="item.COLUMN_NAME" is-link arrow-direction="down" :value="f_date" @click="onSelectDate()" />
				<!-- 单选框 -->
				<van-cell v-else-if="item.IS_ALLOW_EDIT==1 && item.UI_TYPE == 'MultipleCheckBoxSin'" :class="item.IS_MANDATORY==1?'required-x':''" :title="item.LABEL_NAME">
				 	<van-radio-group class="mt5" :name="item.COLUMN_NAME" v-model="f_radio[item.COLUMN_NAME]" direction="horizontal">
				 	  <van-radio v-for="c_item in config_lists[item.COLUMN_NAME]" :name="c_item.VALUE">{{c_item.LABEL_NAME}}</van-radio>
				 	</van-radio-group>
				</van-cell>
				<!-- 多选框 -->
				<van-cell v-else-if="item.IS_ALLOW_EDIT==1 && item.UI_TYPE == 'MultipleCheckBox'" :title="item.LABEL_NAME" :class="item.IS_MANDATORY==1?'t-input required-x':'t-input'">
				 	<van-checkbox-group v-model="f_checkbox[item.COLUMN_NAME]" ref="checkboxGroup">
				 	  <van-checkbox v-for="c_item in config_lists[item.COLUMN_NAME]" shape="square" class="mb10" :name="c_item.VALUE">{{c_item.LABEL_NAME}}</van-checkbox>
				 	</van-checkbox-group>
				</van-cell> 
				<!-- 多行文本框 -->
				<van-cell v-else-if="item.IS_ALLOW_EDIT==1 && item.UI_TYPE == 'TextArea'" :title="item.LABEL_NAME" :class="item.IS_MANDATORY==1?'required-x':''">
					<van-cell-group>
					  <van-field
						v-model="f_textarea[item.COLUMN_NAME]"
						class="textarea"
						rows="2"
						type="textarea"
						:name="item.COLUMN_NAME"
					  />
					</van-cell-group>
				</van-cell>
				<!-- <van-cell v-else :title="item.LABEL_NAME" value="details[item.COLUMN_NAME]" v-model="f_span[item.COLUMN_NAME]"/> -->
			  </div>	
			  <div class="with100">
				  <van-cell v-if="formData.IS_ATTACHED === 1" id="attach-show" title="上传简历" class="last required-x">
				  	<van-uploader name="uploadFile" multiple v-model="fileList" :after-read="afterFiles" :before-delete="deleteFiles" />
				  </van-cell>
			  </div>
			</div>
			<div class="text-center btn-submit fixed bottom60" style="z-index:999;">
				<van-button @click="onSubmit()" type="info" size="large">提交</van-button>
			</div>
			<!-- 数值框 -->
			<van-number-keyboard
			  :show="is_num_show"
			  :maxlength="6"
			  @blur="is_num_show = false"
			/>
			<!-- 时间框 年月日 -->
			<van-popup v-model="is_date_show" position="bottom" :style="{ height: '40%' }">
			  <van-datetime-picker 
			  v-model="currentDate" 
			  type="date"
			  :min-date="minDate"
			  :max-date="maxDate"
			  @change="OnChangeDate()" 
			  @confirm="OnConfirmDate()" 
			  @cancel="OnCancelDate()" />
			</van-popup>
	</van-cell-group>
	<Footer></Footer> <!-- 尾部 -->
	</div>
  </div>
</template>
<script type="text/javascript">
import axios from 'axios';
export default {
  created() {
	var $rus=this.$router.history;
	this.fid=$rus["current"].query.fid;
	if(!this.fid || this.fid==0){
		this.$dialog.alert({
			message: '参数错误',
			showConfirmButton:false,
			overlayClass:"error-user"
		});
	}
	//console.log(JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION')));
	this.getDatas();//获取数据
	this.getDatasConfig();
	this.id=$rus["current"].query.id;
  },
  mounted(){
	  //alert(this.f_textarea["REASON"])
	  //if(this.id>0){  //编辑----获取数据
	  	//this.getDetail();
	  //}
  },
  data() {
    return {
	  ADMIN:JSON.parse(localStorage.getItem('LS_ADMIN')),
	  lists:[],
	  config_lists:[],
	  id:0,
	  fid:0,
	  title_name:"",
	  result:[],
	  details:[],
	  formData:{}, //表单配置信息
	  
	  is_num_show:false,
	  is_date_show:false,
	  minDate: new Date(2020, 0, 1),
	  maxDate: new Date(2026, 12, 1),
	  currentDate: new Date(),
	  //value_list:[],
	  subType_list:[],
	  sublist:{},
	  subName_list:[],
	  
	  f_span:[],
	  f_input:[],
	  f_radio:[],
	  f_checkbox:[],//多选框
	  f_textarea:[],
	  f_number:[],
	  f_date:"",
	  
	  files:[],//提交的文件
	  fileList: []
	};
   },
    filters: {
    },
    methods: {
	   afterFiles:function(file){
	   	//this.files=file.file;
	   	this.files=this.files.concat(file.file);
	   	//$arr=file.file.name.split(".");
	   	//this.files["name"]=	$arr[0];
	   	//this.files["type"]=$arr[1];
	   	//this.files["content"]=file.content;
	   },
	   deleteFiles:function(file,name){
	   	this.files.splice(name.index,1);
	   	return Promise;
	   },
	   onSelectDate: function () {
	   	this.is_date_show = true;	
	   },
	   OnChangeDate: function () {
	   	//this.changeDate = this.currentDate ;
	   },
	   OnConfirmDate: function () {
	   	this.f_date = this.GetDateFormat(this.currentDate);
	   	this.is_date_show = false;
	   },
	   OnCancelDate: function () {
	   	this.is_date_show = false;
	   },
	   GetDateFormat: function (time) {// 时间格式化 2019-09-08
	      let y = time.getFullYear();
	      let MM = time.getMonth() + 1;
	      MM = MM < 10 ? ('0' + MM) : MM;
	      let d = time.getDate();
	      d = d < 10 ? ('0' + d) : d;
	      return y + '-' + MM + '-' + d;
	   },
	   getDetail: function () {
		    axios.get(this.CoreNew.OA_API_IP+"joa-business/joatools/action/"+this.fid+"/"+this.id+"/",{
	   			headers: {'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
	   		}).then(function (response) {
				if(response.data.flag==true){
					this.details=response.data.data;
				}
			}.bind(this)).catch(function (error) { 
				this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--详细信息--失败"+error);//记录错误
				console.log("请求--详细信息--失败"+error); 
			});
	   },
	   getDatas: function () {
		 axios.get(this.CoreNew.OA_API_IP+"joa-business/joatools/formConfig/"+this.fid+"?isMobile=Y&formId=",{
		 	headers: {'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
		 }).then(function (response) {
			if(response.data.flag==true){
				var $rs=response.data.data;
				this.formData =$rs.tformConfig;
				this.lists=$rs.groupFieldConfigList;
				for (var i=0;i<this.lists.length;i++){ 
					for (var j=0;j<this.lists[i].groupFields.length;j++){ 
						if(this.lists[i].groupFields[j].DEFAULT_VALUE=="global_current_user_id"){
							this.sublist[this.lists[i].groupFields[j].COLUMN_NAME]=this.ADMIN.USER_ID;
 						}else if(this.lists[i].groupFields[j].DEFAULT_VALUE=="global_current_user_email"){
							this.sublist[this.lists[i].groupFields[j].COLUMN_NAME]=this.ADMIN.USER_EMAIL;
 						}else if(this.lists[i].groupFields[j].DEFAULT_VALUE=="global_current_user_mobile"){
							this.sublist[this.lists[i].groupFields[j].COLUMN_NAME]=this.ADMIN.USER_PHONE;
 						}else if(this.lists[i].groupFields[j].DEFAULT_VALUE=="global_current_user_dutyname"){
							this.sublist[this.lists[i].groupFields[j].COLUMN_NAME]=this.ADMIN.USER_DUTY_NAME;
 						}else if(this.lists[i].groupFields[j].DEFAULT_VALUE=="global_current_user_department"){
							this.sublist[this.lists[i].groupFields[j].COLUMN_NAME]=this.ADMIN.USER_DEPARTMENT_NAME;
 						}else{
							this.sublist[this.lists[i].groupFields[j].COLUMN_NAME]=this.lists[i].groupFields[j].DEFAULT_VALUE;
						}
						this.subName_list=this.subName_list.concat(this.lists[i].groupFields[j].COLUMN_NAME);
						this.subType_list[this.lists[i].groupFields[j].COLUMN_NAME]=this.lists[i].groupFields[j].UI_TYPE;
					}
				}
				this.title_name=$rs.tformConfig.LABEL_NAME;
				document.title = this.title_name;
			}
	     }.bind(this)).catch(function (error) { 
	     	 this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--公共表单--失败"+error);//记录错误
	     	console.log("请求--公共表单--失败"+error); 
	     });
	   },
	   getDatasConfig: function () {
	   		 axios.get(this.CoreNew.OA_API_IP+"joa-business/joatools/dictionary/findDicInfo?moduleId="+this.fid,{
	   		 	headers: {'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
	   		 }).then(function (response) {
	   			if(response.data.flag==true){
	   				var $rs=response.data.data;
					this.config_lists=$rs;
	   			}
	     }.bind(this)).catch(function (error) { 
	     	 this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--公共表单--失败"+error);//记录错误
	     	console.log("请求--公共表单--失败"+error); 
	     });
	   },
	   //提交
	   onSubmit: function () {
		    var is_success=true;
		    if($(".required-x").length>0){
				var _VUE=this;
				$(".required-x").each(function(){
					if($(this).find("input").val()==""){
						_VUE.$toast($(this).find(".van-cell__title span").html()+"不能为空"); 
						is_success=false;
						return false;
					}else if($(this).find("textarea").val()==""){
						_VUE.$toast($(this).find(".van-cell__title span").html()+"不能为空"); 
						is_success=false;
						return false;
					}else if($(this).find(".van-cell__value span").html()==""){
						_VUE.$toast($(this).find(".van-cell__title span").html()+"不能为空");
						is_success=false;
						return false;
					}
					if($(this).find(".van-cell__title span").html().indexOf("手机")>0){
						is_success=_VUE.Common.checkPhone($(this).find("input").val());
						if(is_success==false){
							_VUE.$toast($(this).find(".van-cell__title span").html()+"格式填写错误"); 
							return false;
						}
					}
					if($(this).find(".van-cell__title span").html().indexOf("邮箱")>0){
						is_success=_VUE.Common.checkEmail($(this).find("input").val());
						if(is_success==false){
							_VUE.$toast($(this).find(".van-cell__title span").html()+"格式填写错误"); 
							return false;
						}
					}
				})
			}
			return false;
			if(is_success==true){
				$("#loading").show();
				//提交的值
				for (var j=0;j<this.subName_list.length;j++){
					if(typeof(this.f_input[this.subName_list[j]])!="undefined"){
						this.sublist[this.subName_list[j]]=this.f_input[this.subName_list[j]];
					}else if(typeof(this.f_radio[this.subName_list[j]])!="undefined"){
						this.sublist[this.subName_list[j]]=this.f_radio[this.subName_list[j]];
					}else if(typeof(this.f_checkbox[this.subName_list[j]])!="undefined"){
						var tmp = this.f_checkbox[this.subName_list[j]].join(',');
						this.sublist[this.subName_list[j]]=tmp;
					}else if(typeof(this.f_textarea[this.subName_list[j]])!="undefined"){
						this.sublist[this.subName_list[j]]=this.f_textarea[this.subName_list[j]];
					}else if(typeof(this.f_number[this.subName_list[j]])!="undefined"){
						this.sublist[this.subName_list[j]]=this.f_number[this.subName_list[j]];
					}else if(this.subName_list[j].indexOf("DATE")>0){
						this.sublist[this.subName_list[j]]=this.f_date;
					}
				}
				var subobj = {"ENTITY_ID":this.fid,"INFO":this.sublist};
				var subobj_all = {"HEADER":subobj};	
				let json_data =JSON.stringify(subobj_all);
				console.log(json_data);
				//axios.post(this.CoreNew.OA_API_IP+"joa-business/joatools/action/"+this.fid+"/",json_data,{
				axios.post(this.CoreNew.OA_API_IP+"joa-business/joatools/action/json/",json_data,{
					headers: {
						'Content-Type': 'application/json',
						'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))
					}
				}).then(function (response) {
					if(response.data.flag==true && response.data.message.indexOf("成功")>0){
						_VUE.$toast("操作成功");
						window.location.href=JSON.parse(localStorage.getItem('LS_WEB_URL'))+'apply/';
					}else{
						_VUE.$toast("操作失败");
					}
					$("#loading").hide();
				}.bind(this)).catch(function (error) { 
					 this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--保存公共表单--失败"+error);//记录错误
					console.log("请求--公共表单--失败"+error); 
				});
			}
	   }
    }
};
</script>
